module.exports = __webpack_public_path__ + "img/icon-pause.ca7fd6af.svg";